import en from './__en';
import vi from './__vi';
import ja from './__ja';

const Translate = {
  en,
  vi,
  ja,
}

export default Translate;